module.exports = __webpack_public_path__ + "static/mike-fix-0397aeda962ecf54ce9ff7d62b973232.jpg";